import { useState } from "react";
import { ClientTitle, CloseModal, ContainerResume, ContentButtons, FinalPrice, Informations, LinkButton, LogoResume, Modal, ModalOverlay, PrintButton, ResumeCard, ResumeInformations, ResumeTitle, StyledCard } from "./style";
import { FaWindowClose } from "react-icons/fa";
import { useOrcamentoContext } from "../../contexts/orcamentoContext";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";


const InfoModal = ({ isOpen, kit, index, onClose }) => {
    const { userData } = useOrcamentoContext()

    if (!isOpen) return null;

    const handleDownloadPdf = async () => {
        const contentElement = document.getElementById("contentPdf");

        if (!contentElement) return;

        try {
            const canvas = await html2canvas(contentElement);
            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
            pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

            // Faz o download
            pdf.save("consulta-renovera.pdf");
        } catch (error) {
            console.error("Erro ao gerar o PDF:", error);
        }
    };

    return (
        <ModalOverlay key={index}>
            <Modal>
                <CloseModal onClick={onClose}><FaWindowClose size={30} /></CloseModal>
                <ResumeTitle>Resumo do pedido</ResumeTitle>
                <ClientTitle>Cliente: {userData?.client_name}</ClientTitle>
                <ContainerResume>
                    <ResumeCard>
                        <div>
                            <img src="/card_image1.png" />
                            <p id='potencia'>{kit?.modulo?.potencia_pico_total} kWp</p>
                        </div>
                        <div>
                            <img src="/card_image2.png" />
                            <p>{kit?.distribuidor} </p>
                        </div>
                        <div>
                            <img src="/card_image3.png" />
                            <p>{kit?.inversor?.produto}</p>
                        </div>
                        <div>
                            <img src="/card_image4.png" />
                            <p>
                                {kit?.estrutura?.[0]?.estrutura_fixacao?.replace("colonialceramico", "COLONIAL/CERÂMICO")}
                            </p>
                        </div>
                    </ResumeCard>
                    <ResumeInformations>
                        <table>
                            <thead>
                                <tr>
                                    <td>ITEM</td>
                                    <td width="100px">QTD</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><strong>Módulo:</strong> {kit?.modulo?.produto}</td>
                                    <td>{kit?.modulo?.quantidade}</td>
                                </tr>
                                <tr>
                                    <td><strong>Inversor:</strong> {kit?.inversor?.produto}</td>
                                    <td>{kit?.inversor?.quantidade}</td>
                                </tr>
                                <tr>
                                    <td><strong>Cabos:</strong> {kit?.cabos?.[0]?.produto}</td>
                                    <td>{kit?.cabos?.[0]?.quantidade}</td>
                                </tr>
                                <tr>
                                    <td><strong>Cabos:</strong> {kit?.cabos?.[1]?.produto}</td>
                                    <td>{kit?.cabos?.[1]?.quantidade}</td>
                                </tr>
                                <tr>
                                    <td><strong>Estrutura:</strong> {kit?.estrutura?.[0]?.produto}</td>
                                    <td>{kit?.estrutura?.[0]?.quantidade}</td>
                                </tr>
                                <tr>
                                    <td><strong>Conectores:</strong> {kit?.conectores?.[0]?.produto}</td>
                                    <td>{kit?.conectores?.[0]?.quantidade}</td>
                                </tr>
                            </tbody>
                        </table>
                    </ResumeInformations>
                </ContainerResume>
                <FinalPrice id='valor-kit'>
                    Total: {
                        new Intl.NumberFormat("pt-BR",
                            {
                                style: "currency",
                                currency: "BRL"
                            }
                        )
                            .format(kit?.valor_kit)}
                </FinalPrice>
                <ContentButtons>
                    <LinkButton className="linkTo" href="https://www.renovera.com.br/cadastro" target="blank_">Comprar</LinkButton>
                    <PrintButton onClick={handleDownloadPdf}>Download</PrintButton>
                </ContentButtons>

                <Informations id="contentPdf">
                    <LogoResume src="/logo-renovera.svg" />
                    <ResumeTitle>Resumo do pedido</ResumeTitle>
                    <p style={{ maxWidth: "600px", textAlign: "center", display: "block", margin: "auto", marginTop: "10px" }}>Se estiver logado na plataforma, você poderá editar a quantidade dos itens de sua proposta, com exceção dos kits fechados que não é possível realizar a alteração.</p>
                    <span style={{ backgroundColor: "orange", color: "#000000", display: "block", fontSize: "12px", borderRadius: "5px", textAlign: "center", margin: "20px auto", width: "190px", padding: "5px", position: "absolute", top: "30px", right: "50px" }}>Orçamento válido por 3 dias úteis</span>
                    <ClientTitle>Cliente: {userData?.client_name}</ClientTitle>
                    <ContainerResume>
                        <ResumeCard>
                            <div>
                                <img src="/card_image1.png" />
                                <p id='potencia'>{kit?.modulo?.potencia_pico_total} kWp</p>
                            </div>
                            <div>
                                <img src="/card_image2.png" />
                                <p>{kit?.distribuidor} </p>
                            </div>
                            <div>
                                <img src="/card_image3.png" />
                                <p>{kit?.inversor?.produto}</p>
                            </div>
                            <div>
                                <img src="/card_image4.png" />
                                <p>
                                    {kit?.estrutura?.[0]?.estrutura_fixacao?.replace("colonialceramico", "COLONIAL/CERÂMICO")}
                                </p>
                            </div>

                        </ResumeCard>
                        <ResumeInformations>
                            <table>
                                <thead>
                                    <tr>
                                        <td>ITEM</td>
                                        <td width="100px">QTD</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><strong>Módulo:</strong> {kit?.modulo?.produto}</td>
                                        <td>{kit?.modulo?.quantidade}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Inversor:</strong> {kit?.inversor?.produto}</td>
                                        <td>{kit?.inversor?.quantidade}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Cabos:</strong> {kit?.cabos?.[0]?.produto}</td>
                                        <td>{kit?.cabos?.[0]?.quantidade}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Cabos:</strong> {kit?.cabos?.[1]?.produto}</td>
                                        <td>{kit?.cabos?.[1]?.quantidade}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Estrutura:</strong> {kit?.estrutura?.[0]?.produto}</td>
                                        <td>{kit?.estrutura?.[0]?.quantidade}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Conectores:</strong> {kit?.conectores?.[0]?.produto}</td>
                                        <td>{kit?.conectores?.[0]?.quantidade}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </ResumeInformations>
                    </ContainerResume>
                    <FinalPrice id='valor-kit'>
                        Total: {
                            new Intl.NumberFormat("pt-BR",
                                {
                                    style: "currency",
                                    currency: "BRL"
                                }
                            )
                                .format(kit?.valor_kit)}
                    </FinalPrice>
                    <div className="condicoes">
                        <strong>Condições</strong>
                        <p>- Frete: CIF</p>
                        <p>- Prazo estimado de entrega (a partir da disponibilidade dos equipamentos): 5 dias úteis</p>
                        <p>- Descarga dos produtos é de exclusiva responsabilidade do integrador</p>
                    </div>
                    <div className="pagamento">
                        <strong>Pagamento</strong>
                        <p>- Financiamento Externo</p>
                        <p>- Cartão de crédito</p>
                        <p>- Pix</p>
                        <p>- Boleto Bancário</p>
                    </div>
                    <div className="info">
                        <strong>Outras informações</strong>
                        <p>1 – As mercadorias só serão reservadas mediante o pagamento do pedido;</p>
                        <p>2 – A estrutura de fixação fornecida deve ser seguida a Instalação de 4 em 4 módulos na posição retrato;</p>
                        <p>3 – Após o pagamento em conta o pedido será despachado em até 5 dias úteis;</p>
                        <p>4 – A proposta pode ser revisada mediante a disponibilidade do material e variação cambial;</p>
                        <p>5 – O prazo de entrega estimado, é contabilizado após o despacho do pedido;</p>
                        <p>6 – A Renovera não se responsabiliza por nenhuma premissa de dimensionamento do projeto, instalação e geração. É de total responsabilidade do integrador.</p>
                        <p>7 – O frete CIF contempla descarregamento, sendo de total responsabilidade do integrador a conferência do material e ressalva imediata no recebimento, qualquer reclamação posterior terá maior dificuldade na tratativa;</p>
                        <p>8 – Para produtos com venda provisionada, a data informada é uma previsão de chegada no centro de distribuição do distribuidor. O prazo de entrega começa a ser contabilizado após a chegada e o faturamento dos materiais. O cliente, ao confirmar e seguir com o pedido, concorda que a Renovera não tem responsabilidade por atrasos na importação dos mesmos. A Renovera se compromete a resolver quaisquer problemas da melhor maneira possível e manter o cliente informado.</p>
                    </div>
                    <div style={{ marginTop: "230px", textAlign: "center" }} className="info">
                        <LogoResume style={{ marginBottom: "0px" }} src="/brasao.png" />
                        <p>RENOVERA ENERGIAS RENOVAVEIS LTDA</p>
                        <p>CNPJ: 57.377.391/0001-85</p>
                        <p>Rua Gabriel Ferreira, n.29, Sala 12 - Centro - São João da Boa Vista/SP - Cep: 13870-180.</p>
                    </div>
                </Informations>
            </Modal>
        </ModalOverlay>
    );
};

function KitCard({ kit, index }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [filterId, setFilterId] = useState(null);

    const handleOpenModal = (id) => {
        setFilterId(id);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setFilterId(null);
    };

    return (
        <>
        <StyledCard key={index}>
            
            <div className="icon-text-item">
                <img src="/card_image1.png" alt="Ícone Potência" /> 
                <p id='potencia'>{kit?.modulo?.potencia_pico_total} kWp</p>
            </div>
           
            <div className="icon-text-item">
                <img src="/card_image2.png" alt="Ícone Distribuidor" /> 
                <p>{kit?.distribuidor} </p>
            </div>
           
            <div className="icon-text-item">
                <img src="/card_image3.png" alt="Ícone Inversor" /> 
                <p>{kit?.inversor?.produto}</p>
            </div>
        
            <div className="icon-text-item">
                <img src="/card_image4.png" alt="Ícone Estrutura" /> 
                <p>
                    {kit?.estrutura?.[0]?.estrutura_fixacao?.replace("colonialceramico", "COLONIAL/CERÂMICO")}
                </p>
            </div>

            <p id='valor-kit'>
                {
                    new Intl.NumberFormat("pt-BR",
                        {
                            style: "currency",
                            currency: "BRL"
                        }
                    )
                        .format(kit?.valor_kit)}
            </p>
       
            <div style={{ display: 'flex', gap: "1em", justifyContent: 'center', margin: "15px" }}>
                <button onClick={() => handleOpenModal(index)}>DETALHES</button>
            </div>
        </StyledCard>
        <InfoModal isOpen={isModalOpen} kit={kit} index={index} filterId={filterId} onClose={closeModal} />
    </>
    )
}

export default KitCard